var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 391.984 391.984",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M368.701,31.839H23.283C10.445,31.839,0,42.284,0,55.123v281.738c0,12.84,10.445,23.284,23.283,23.284h345.418 c12.84,0,23.283-10.444,23.283-23.284V55.123C391.984,42.284,381.541,31.839,368.701,31.839z M161.152,61.149 c0-2.923,2.393-5.315,5.314-5.315h31.871c2.923,0,5.313,2.392,5.313,5.315v9.994c0,2.923-2.393,5.315-5.313,5.315h-31.871 c-2.922,0-5.314-2.392-5.314-5.315V61.149z M95.716,61.149c0-2.923,2.393-5.315,5.314-5.315h31.869 c2.924,0,5.314,2.392,5.314,5.315v9.994c0,2.923-2.391,5.315-5.314,5.315H101.03c-2.922,0-5.314-2.392-5.314-5.315V61.149z  M31.937,61.149c0-2.923,2.393-5.315,5.314-5.315H69.12c2.924,0,5.314,2.392,5.314,5.315v9.994c0,2.923-2.391,5.315-5.314,5.315 H37.251c-2.922,0-5.314-2.392-5.314-5.315V61.149z M373.357,333.796c0,3.064-2.533,5.572-5.625,5.572H24.253 c-3.094,0-5.625-2.508-5.625-5.572V101.668c0-3.065,2.531-5.573,5.625-5.573h343.479c3.092,0,5.625,2.508,5.625,5.573V333.796z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.ce626ea68c055d0ce5fcb304b7a032dc.svg";
export { ForwardRef as ReactComponent };